<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div id="uploaded">
    <h2>アップロードが完了しました</h2>
    <p v-if="this.$route.query.msg" class="has-text-danger">{{ this.$route.query.msg }}</p>
    <hr>
    <div v-for="file in this.$store.state.uploadedFilesName" :key="file.id" class="list">
      <div class="list-item">
        <img v-if="file.extension === 'png' || file.extension === 'jpg' || file.extension === 'jpeg' || file.extension === 'gif'" style="width:200px" v-bind:src="baseURL+'/upload/'+file.name+'?show=true'"/>
        <img v-else style="width:200px" src="/static/images/document.svg" />
        <p>{{ file.name }}</p>
      </div>
      <section class="copy">
        <p v-if="isCopied" class="has-text-info">URLをコピーしました</p>
        <button @click="exec('https://files-uploader.xzy.pw/upload/' + file.name)" class="button is-primary">URLをコピー
        </button>
      </section>
    </div>
    <modal name="buymeacoffee" adaptive>
      <div class="buymeacoffee has-text-centered">
        <h2>運営維持のためにコーヒーを私に...</h2>
        <br>
        <link href="https://fonts.googleapis.com/css?family=Cookie" rel="stylesheet">
        <a class="bmc-button" target="_blank" href="https://www.buymeacoffee.com/zTUrf4e"><img
          src="https://www.buymeacoffee.com/assets/img/BMC-btn-logo.svg" alt="Buy me a coffee"><span
          style="margin-left:5px">Buy me a coffee</span></a>
        <br>
        <br>
        <button class="button is-success" @click="$modal.hide('buymeacoffee')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  name: 'Uploaded',
  data: function () {
    return {
      message: 'copy text',
      isCopied: false
    }
  },
  methods: {
    exec: function (value) {
      if (this.execCopy(value) === false) {
        alert('このブラウザでは対応していません')
      } else {
        this.isCopied = true
      }
    },
    execCopy: function (string) {
      let temp = document.createElement('div')
      temp.appendChild(document.createElement('pre')).textContent = string
      let s = temp.style
      s.position = 'fixed'
      s.left = '-100%'
      document.body.appendChild(temp)
      document.getSelection().selectAllChildren(temp)
      let result = document.execCommand('copy')
      document.body.removeChild(temp)
      return result
    }
  },
  mounted: function () {
    this.$modal.show('buymeacoffee')
  }
}
</script>

<style scoped>
  .buymeacoffee {
    padding: 3rem;
  }
  .bmc-button img {
    width: 27px !important;
    margin-bottom: 1px !important;
    box-shadow: none !important;
    border: none !important;
    vertical-align: middle !important;
  }

  .bmc-button {
    line-height: 36px !important;
    height: 37px !important;
    text-decoration: none !important;
    display: inline-flex !important;
    color: #FFFFFF !important;
    background-color: #FF813F !important;
    border-radius: 3px !important;
    border: 1px solid transparent !important;
    padding: 1px 9px !important;
    font-size: 22px !important;
    letter-spacing: 0.6px !important;
    box-shadow: 0px 1px 2px rgba(190, 190, 190, 0.5) !important;
    -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
    margin: 0 auto !important;
    font-family: 'Cookie', cursive !important;
    -webkit-box-sizing: border-box !important;
    box-sizing: border-box !important;
    -o-transition: 0.3s all linear !important;
    -webkit-transition: 0.3s all linear !important;
    -moz-transition: 0.3s all linear !important;
    -ms-transition: 0.3s all linear !important;
    transition: 0.3s all linear !important;
  }

  .bmc-button:hover, .bmc-button:active, .bmc-button:focus {
    -webkit-box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
    text-decoration: none !important;
    box-shadow: 0px 1px 2px 2px rgba(190, 190, 190, 0.5) !important;
    opacity: 0.85 !important;
    color: #FFFFFF !important;
  }

  .copy {
    padding: 1rem 0 1rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Uploaded.vue